import { QueryGroup, QuerySubGroup } from '../../services/types/Grievance';

export const GRIEVANCE_PHASES = {
  CLOSED: 'Closed',
  NOT_APPLICABLE: 'N/A',
  APPLICABILITY: 'Applicability',
  ASSESSMENT_AND_RESPONSE: 'A&R',
  MONITORING: 'Monitoring',
};

export const ALL_COLUMNS: string[] = [
  'number',
  'claimantName',
  'grievanceGender',
  'countryClaimantOfResidence',
  'emailClaimant',
  'phoneClaimant',
  'grievanceDescription',
  'isApplicable',
  'grievanceStatus',
  'currentPhaseName',
  'registrationDate',
  'grievanceTimeElapsed',
  'programOrPrjNumber',
  'programOrPrjCountry',
  'programOrPrjName',
  'operationCountry',
  'mainTopicName',
  'subTopicName',
  'secondarySubTopicName',
  'trackType',
  'prioritization',
  'isConfidential',
  'originPrimary',
  'originSecondary',
  'channelPrimary',
  'channelSecondary',
  'isPGM',
  'noPGMReason',
  'isInminentRisk',
  'imminentRiskTypes',
  'imminentRiskTypeOther',
  'isConfidentialityChange',
  'confidentialityChangeDate',
  'confidentialityChangeReason',
  'isGroupClaim',
  'groupClaimNumber',
  'groupDialogueProcess',
  'relatedGrievanceNumber',
  'relatedGrievance',
  'relateds',
  'isReopenedCase',
  'previousGrievanceNumber',  
  // 'previousGrievanceId',
  'primaryGrievanceNumber',
  'operationNumber',
  'operationId',
  'operationName',
  'operationSector',
  'region',
  'operationContractor',
  'executingAgency',
  'operationTeamLeader',
  'operationPrimaryMember',
  'operationMembers',
  'operationEsic',
  'operationDccrc',
  'operationEsrr',
  'operationSpr',
  'operationSprDate',
  'operationSprRationale',
  'previousSPR',
  'previousSPRDate',
  'previousSPRRationale',
  'espsPoliciesWithRequirements',
  'operationStatus',
  'lastDisbDate',
  'disbursedPercentage',
  'lendingTypeModality',
  'miciCases',
  'confirmationOfRegistryToComplainant',
  'applicabilityNotificationDate',
  'listeningSpaceDate',
  'agreementOnActionPlanDate',
  'monitoringNotificationDate',
  'receptionOfActionPlanDocumentDate',
  'verificationWithComplainantDate',
  'authorizationOfClosure',
  'closureNotificationDate',
  'closureType',
  'additionalActions',
  'isClaimantMICIInformed',
  'handledByMICIAfterwards',
];

export const VISIBLE_COLUMNS_BY_PHASE: Record<string, string[]> = {
  [QueryGroup.All]: [
    'number',
    'claimantName',
    'isApplicable',
    'grievanceStatus',
    'currentPhaseName',
    'registrationDate',
    'grievanceTimeElapsed',
    'mainTopicName',
    'subTopicName',
    'trackType',
    'prioritization',
    'isConfidential',
    'groupDialogueProcess',
    'relatedGrievanceNumber',
    'relateds',
    'operationNumber',
    'operationSector',
    'region',
    'executingAgency',
    'operationPrimaryMember',
    'operationEsrr',
    'operationSpr',
    'espsPoliciesWithRequirements',
    'disbursedPercentage',
    'applicabilityNotificationDate',
    'agreementOnActionPlanDate',
    'monitoringNotificationDate',
    'authorizationOfClosure',
    'closureNotificationDate',
    'closureType',
  ],
  [`${QueryGroup.InProgress}-${QuerySubGroup.All}`]: [
    'number',
    'claimantName',
    'isApplicable',
    'currentPhaseName',
    'registrationDate',
    'grievanceTimeElapsed',
    'mainTopicName',
    'subTopicName',
    'trackType',
    'prioritization',
    'isConfidential',
    'groupDialogueProcess',
    'relateds',
    'operationNumber',
    'operationSector',
    'region',
    'executingAgency',
    'operationPrimaryMember',
    'operationEsrr',
    'operationSpr',
    'espsPoliciesWithRequirements',
    'disbursedPercentage',
    'applicabilityNotificationDate',
    'agreementOnActionPlanDate',
    'monitoringNotificationDate',
    // 'authorizationOfClosure',
  ],
  [`${QueryGroup.InProgress}-${QuerySubGroup.Applicability}`]: [
    'number',
    'claimantName',
    'isApplicable',
    'registrationDate',
    'grievanceTimeElapsed',
    'mainTopicName',
    'subTopicName',
    'trackType',
    'prioritization',
    'isConfidential',
    'operationNumber',
    'operationId',
    'operationSector',
    'region',
    'executingAgency',
    'operationPrimaryMember',
    'operationEsrr',
    'operationSpr',
    'espsPoliciesWithRequirements',
    'disbursedPercentage',
    'confirmationOfRegistryToComplainant',
    'applicabilityNotificationDate',
  ],
  [`${QueryGroup.InProgress}-${QuerySubGroup.AssessmentAndResponse}`]: [
    'number',
    'claimantName',
    'registrationDate',
    'grievanceTimeElapsed',
    'mainTopicName',
    'subTopicName',
    'trackType',
    'prioritization',
    'groupDialogueProcess',
    'relatedGrievanceNumber',
    'relatedGrievance',
    'relateds',
    'operationNumber',
    'operationId',
    'operationSector',
    'region',
    'executingAgency',
    'operationPrimaryMember',
    'operationEsrr',
    'operationSpr',
    'espsPoliciesWithRequirements',
    'disbursedPercentage',
    'listeningSpaceDate',
    'agreementOnActionPlanDate',
  ],
  [`${QueryGroup.InProgress}-${QuerySubGroup.Monitoring}`]: [
    'number',
    'claimantName',
    'registrationDate',
    'grievanceTimeElapsed',
    'mainTopicName',
    'subTopicName',
    'trackType',
    'prioritization',
    'groupDialogueProcess',
    'relatedGrievanceNumber',
    'relatedGrievance',
    'relateds',
    'operationNumber',
    'operationId',
    'operationSector',
    'region',
    'executingAgency',
    'operationPrimaryMember',
    'operationEsrr',
    'operationSpr',
    'espsPoliciesWithRequirements',
    'disbursedPercentage',
    'monitoringNotificationDate',
    'receptionOfActionPlanDocumentDate',
    'verificationWithComplainantDate',
    // 'authorizationOfClosure',
  ],
  [`${QueryGroup.ClosedAndNotApplicable}-${QuerySubGroup.All}`]: [
    'number',
    'claimantName',
    'grievanceStatus',
    'currentPhaseName',
    'registrationDate',
    'grievanceTimeElapsed',
    'mainTopicName',
    'subTopicName',
    'groupDialogueProcess',
    'relatedGrievanceNumber',
    'relatedGrievance',
    'relateds',
    'operationNumber',
    'operationId',
    'operationSector',
    'region',
    'executingAgency',
    'operationPrimaryMember',
    'operationEsrr',
    'operationSpr',
    'espsPoliciesWithRequirements',
    'closureNotificationDate',
    'closureType',
  ],
  [`${QueryGroup.ClosedAndNotApplicable}-${QuerySubGroup.Closed}`]: [
    'number',
    'claimantName',
    'registrationDate',
    'grievanceTimeElapsed',
    'mainTopicName',
    'subTopicName',
    'groupDialogueProcess',
    'relatedGrievanceNumber',
    'relatedGrievance',
    'relateds',
    'operationNumber',
    'operationId',
    'operationSector',
    'region',
    'executingAgency',
    'operationPrimaryMember',
    'operationEsrr',
    'operationSpr',
    'espsPoliciesWithRequirements',
    'authorizationOfClosure',
    'closureNotificationDate',
    'closureType',
  ],
  [`${QueryGroup.ClosedAndNotApplicable}-${QuerySubGroup.NotApplicable}`]: [
    'number',
    'claimantName',
    'registrationDate',
    'mainTopicName',
    'subTopicName',
    'operationNumber',
    'operationId',
    'operationSector',
    'region',
    'executingAgency',
    'operationPrimaryMember',
    'operationEsrr',
    'operationSpr',
  ],
};

/**
 * Returns the list of hidden columns for a given phase key.
 * Accepts either a plain QueryGroup (e.g. QueryGroup.All) or a combined
 * 'QueryGroup-QuerySubGroup' key (e.g. 'InProgress-Applicability').
 */
export function getHiddenColumnsForPhase(phaseKey: string): string[] {
  const visibleColumns =
    VISIBLE_COLUMNS_BY_PHASE[phaseKey] || VISIBLE_COLUMNS_BY_PHASE[QueryGroup.All];
  return ALL_COLUMNS.filter((col) => !visibleColumns.includes(col));
}
